import { Layout } from "antd";
import { Footer } from "antd/lib/layout/layout";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMenuCollapsed } from "../../state/globalStore";
import { RootState } from "../../store";
import AppHeader from "./AppHeader";
import "./AuthedLayout.less";
import BackOfficeSideMenu from "./side-menu/back-office-side-menu";

const { Content } = Layout;

const AuthedLayout = ({ ...props }) => {
  const dispatch = useDispatch();
  const { menuCollapsed } = useSelector((state: RootState) => state.global);

  const toggle = () => dispatch(setMenuCollapsed());

  return (
    <>
      <Layout style={{ height: "100vh" }}>
        <BackOfficeSideMenu collapsed={menuCollapsed} />
        <Layout className="site-layout">
          <AppHeader collapsed={menuCollapsed} onClick={toggle} />
          <Content
            style={{
              padding: 10,
              minHeight: 280,
              overflow: "auto",
              marginLeft: 24,
              marginRight: 0
            }}
          >
            {props.children}
          </Content>
          <Footer style={{ textAlign: "center" }}>
            <p>
              ©{moment().format("YYYY")} Copyright Civica North America, Inc., <a href="https://civica.com">d.b.a. Civica</a>. All rights reserved.
            </p>
          </Footer>
        </Layout>
      </Layout>
    </>
  );
};

export default AuthedLayout;
